var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.25033 18.9557H5.75033C2.49199 18.9557 1.04199 17.5057 1.04199 14.2474V10.7474C1.04199 7.48906 2.49199 6.03906 5.75033 6.03906H9.25033C12.5087 6.03906 13.9587 7.48906 13.9587 10.7474V14.2474C13.9587 17.5057 12.5087 18.9557 9.25033 18.9557ZM5.75033 7.28906C3.16699 7.28906 2.29199 8.16406 2.29199 10.7474V14.2474C2.29199 16.8307 3.16699 17.7057 5.75033 17.7057H9.25033C11.8337 17.7057 12.7087 16.8307 12.7087 14.2474V10.7474C12.7087 8.16406 11.8337 7.28906 9.25033 7.28906H5.75033Z",
    fill: "#3EC1CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.2503 13.9557H13.3337C12.992 13.9557 12.7087 13.6724 12.7087 13.3307V10.7474C12.7087 8.16406 11.8337 7.28906 9.25033 7.28906H6.66699C6.32533 7.28906 6.04199 7.00573 6.04199 6.66406V5.7474C6.04199 2.48906 7.49199 1.03906 10.7503 1.03906H14.2503C17.5087 1.03906 18.9587 2.48906 18.9587 5.7474V9.2474C18.9587 12.5057 17.5087 13.9557 14.2503 13.9557ZM13.9587 12.7057H14.2503C16.8337 12.7057 17.7087 11.8307 17.7087 9.2474V5.7474C17.7087 3.16406 16.8337 2.28906 14.2503 2.28906H10.7503C8.16699 2.28906 7.29199 3.16406 7.29199 5.7474V6.03906H9.25033C12.5087 6.03906 13.9587 7.48906 13.9587 10.7474V12.7057Z",
    fill: "#3EC1CF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.574af475d4c1d683174bbee01d497ece.svg";
export { ForwardRef as ReactComponent };